import React from 'react';
import Tooltip from '../../Tooltip';

type Props = {
  onClick: () => void;
  label: string;
};

const ClosedCaptionsClose = ({ onClick, label }: Props) => {
  return (
    <Tooltip
      content={label}
      size="medium"
      theme="dark"
      pointerPosition="top-center"
    >
      <button type="button" className="closed-captions-close" onClick={onClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 25 25"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.91789 4.63615C5.30842 4.24563 5.94158 4.24563 6.33211 4.63615L12.625 10.929L18.9179 4.63615C19.3084 4.24563 19.9416 4.24563 20.3321 4.63615C20.7226 5.02668 20.7226 5.65984 20.3321 6.05037L14.0392 12.3433L20.3321 18.6362C20.7226 19.0267 20.7226 19.6598 20.3321 20.0504C19.9416 20.4409 19.3084 20.4409 18.9179 20.0504L12.625 13.7575L6.33211 20.0504C5.94158 20.4409 5.30842 20.4409 4.91789 20.0504C4.52737 19.6598 4.52737 19.0267 4.91789 18.6362L11.2108 12.3433L4.91789 6.05037C4.52737 5.65984 4.52737 5.02668 4.91789 4.63615Z"
            fill="currentColor"
          ></path>
        </svg>
      </button>
    </Tooltip>
  );
};

export default ClosedCaptionsClose;
